module.exports = __webpack_public_path__ + "static/0059-35f24d23177259bcbdcd2d803cf93022.png";